
    import '/opt/buildhome/repo/packages/x/docs/x-card/demo/A2UI_v0.8/progressive.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-card/demo/A2UI_v0.8/progressive.md?type=demo')
};